/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Import_Url_DescInputs */

const en_jobs_import_url_desc = /** @type {(inputs: Jobs_Import_Url_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-extract job details from a posting link`)
};

const de_jobs_import_url_desc = /** @type {(inputs: Jobs_Import_Url_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellendetails automatisch aus einem Link extrahieren`)
};

const fr_jobs_import_url_desc = /** @type {(inputs: Jobs_Import_Url_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraire automatiquement les détails d'un poste à partir d'un lien`)
};

const es_jobs_import_url_desc = /** @type {(inputs: Jobs_Import_Url_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraer automáticamente los detalles de un puesto desde un enlace`)
};

const it_jobs_import_url_desc = /** @type {(inputs: Jobs_Import_Url_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrai automaticamente i dettagli del lavoro da un link all'annuncio`)
};

const nl_jobs_import_url_desc = /** @type {(inputs: Jobs_Import_Url_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haal automatisch vacaturedetails op uit een link`)
};

const pl_jobs_import_url_desc = /** @type {(inputs: Jobs_Import_Url_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatycznie wyodrębnij szczegóły oferty z linku do ogłoszenia`)
};

const fi_jobs_import_url_desc = /** @type {(inputs: Jobs_Import_Url_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poimi työpaikan tiedot automaattisesti ilmoituksen linkistä`)
};

const da_jobs_import_url_desc = /** @type {(inputs: Jobs_Import_Url_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-udtræk jobdetaljer fra et opslagslink`)
};

const sv_jobs_import_url_desc = /** @type {(inputs: Jobs_Import_Url_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extrahera jobbdetaljer automatiskt från en annonslänk`)
};

/**
* | output |
* | --- |
* | "Auto-extract job details from a posting link" |
*
* @param {Jobs_Import_Url_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_import_url_desc = /** @type {((inputs?: Jobs_Import_Url_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Import_Url_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_import_url_desc(inputs)
	if (locale === "fr") return fr_jobs_import_url_desc(inputs)
	if (locale === "es") return es_jobs_import_url_desc(inputs)
	if (locale === "it") return it_jobs_import_url_desc(inputs)
	if (locale === "nl") return nl_jobs_import_url_desc(inputs)
	if (locale === "pl") return pl_jobs_import_url_desc(inputs)
	if (locale === "fi") return fi_jobs_import_url_desc(inputs)
	if (locale === "da") return da_jobs_import_url_desc(inputs)
	if (locale === "sv") return sv_jobs_import_url_desc(inputs)
	return en_jobs_import_url_desc(inputs)
});